import { ICRMSessionHandler } from '../CRMHandler';
import { VeevaVaultAPIService } from '../Syncers/VeevaVault/VeevaVaultAPIService';
import { CRMIntegrationSession } from 'src/state/machines/CRM/util';

export class VeevaVaultSessionHandler implements ICRMSessionHandler {
  readonly apiService: VeevaVaultAPIService;

  constructor() {
    this.apiService = new VeevaVaultAPIService();
  }

  async logOut(crmSession?: CRMIntegrationSession): Promise<void> {
    await this.apiService.endSession(crmSession);
  }

  async keepSessionAlive(): Promise<void> {
    await this.apiService.keepSessionAlive();
  }
}
